
const storage = (cartitem)=>{
   localStorage.setItem('cartitem',JSON.stringify(cartitem.length?cartitem:[]))
}

 const Reducer = (state,action)=>{
   
  let index = -1
 if(action.payload)
  index = state.title.findIndex(x=>x.id===action.payload.id)
  let item = action.payload
  let quality= 1
  let newitem = [...state.title]

    switch(action.type){
      
      case 'Add' : 
      case 'increment':
   
      if(index===-1){
         newitem.push({...item,quality} )
         }
         else{
            newitem[index].quality++
   
      }
   break ;
   case 'decrement':
      if(index>-1){
         if(newitem[index].quality>1)
         newitem[index].quality--
      }
         
         
 break ;
      
    

   case 'del' :
      if(index>-1){
         newitem = state.title.filter(x => x.id !== action.payload.id)
        
      }
      break ;

      case 'remove':
      newitem = [] ;
         break ;
   
     default:

        
      
   }

   state.title =  newitem ;
   storage(newitem )
 return state
    }
    
export default  Reducer